import { MirrorControl } from './mirror';
import { IntegerControl, NumberControl } from './number';
import { NumberWithUnitsControl } from './number-with-units';
import { TextControl } from './text';


export const CONTROL_COMPONENTS_BY_NAME = {
    IntegerControl,
    MirrorControl,
    NumberControl,
    NumberWithUnitsControl,
    TextControl,
};
